export default {
  Debit: 1,
  Credit: 2,
  Prepaid: 3,
  Unknown: 4
}
